const AddonLoadPageEvent = {
  mounted() {
    this.$store.dispatch('startPageLoading').then(() => {
      return this.loadPage();
    }).finally(() => this.$store.dispatch('stopPageLoading'));
  },
  methods: {
    loadPage() {
      // Overrideしない場合はアカウント情報取得APIを実行する
      return this.$store.dispatch('account/refresh');
    }
  }
};

export default AddonLoadPageEvent;
